// import 'react-select/dist/react-select.css';
import classNames from 'classnames';
import Select from 'react-select';

const InputSelect = ({ name, value, onChange, className, options, placeholder, ...props }) => {
    return (
        <Select
            name={name}
            value={value}
            onChange={onChange}
            options={options}
            className={classNames('KA-select', className)}
            placeholder={placeholder}
            {...props}
        />
    )
}

export default InputSelect;
